module.exports = "data:image/webp;base64,UklGRkYAAABXRUJQVlA4IDoAAAAQAwCdASoZABkAPpFCnEolo6KhqAgAsBIJaQDPoBdvrAAA/vaN1mjse7aVpq3AzXlpHU+JHE+xygAA"


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/white.webp
// module id = ajfJ
// module chunks = 14